module.exports = __webpack_public_path__ + "static/xill-c178086df0a5e2391f40abc6c0adbfda.jpeg";